var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"pot-rate-item",class:{ 'pot-rate-item_active': _vm.index <= _vm.$parent.tempValue }},[_vm._t("default",[_c('div',{staticClass:"pot-rate-item-def"})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }